module.exports = __webpack_public_path__ + "img/logo-all.73177ce8.png";